export const MAP_SETTINGS_TOOLS_STATE_BOUNDARY_SET_FILTER = 'MAP_SETTINGS_TOOLS_STATE_BOUNDARY_SET_FILTER';
export const MAP_SETTINGS_TOOLS_STATE_BOUNDARY_SET_LOCATIONS_FILTER = 'MAP_SETTINGS_TOOLS_STATE_BOUNDARY_SET_LOCATIONS_FILTER';
export const MAP_SETTINGS_TOOLS_STATE_BOUNDARY_CLEAR_LOCATIONS_FILTER = 'MAP_SETTINGS_TOOLS_STATE_BOUNDARY_CLEAR_LOCATIONS_FILTER';
